import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-select" }


import QSelect from 'quasar/src/components/select/QSelect.js';;
import {
  PropType,
  ref,
  reactive,
  computed,
  onMounted,
  watch,
  defineExpose,
  nextTick,
} from 'vue';
import { actionHandler } from '~actions/actionHandler';
import {
  Action, ISearchFromBackend, ITable, TableRow,
} from '@/components/TableComponent/types';
import { arrayUnique } from '@/components/TableComponent/helpers';
import BugReport from '@/components/BugReport.vue';

const __default__ = {
  name: 'SearchSelect',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id_name: {
    type: String as PropType<string>,
    default: () => '',
  },
  field: {
    type: String as PropType<string>,
    default: () => '',
  },
  label: {
    type: String as PropType<string>,
  },
  valueVariant: {
    type: String as PropType<string | null>,
  },
  custom: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  // autoshow: {
  //   type: Boolean,
  //   default: () => false,
  // },
  options: {
    type: Array as PropType<TableRow[]>,
    default: () => [],
  },
  searchFromBackend: {
    type: Object as PropType<ISearchFromBackend>,
  },
  filter: {
    type: Boolean as PropType<boolean>,
    default: () => true,
  },
  isRestoringState: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
},
  emits: ['select', 'filter', 'popupShow', 'changeType', 'remove', 'update:modelValue'],
  setup(__props, { expose, emit }) {

const props = __props





const selectedValue = ref<string | null>(null);

const test = ref();

const _options = ref(props.options);

const _value = ref(props.valueVariant);

const state = reactive({
  inputMode: false,
  searchStr: '',
  backspaceFlag: false,
});

const applyFilter = computed(() => _options.value.filter(
  (v: any) => JSON.stringify(v).toLowerCase().includes(state.searchStr.toLowerCase()),
));

// watch(
//   () => selectedValue.value,
//   (val) => {
//     if (!val) emit('remove');
//   },
// );

const detectBackspace = (some: any) => {
  state.backspaceFlag = true;
  setTimeout(() => {
    state.backspaceFlag = false;
  }, 300);
};

const filterFn = async (val: string, update: any) => {
  if (val === '') {
    update(() => {
      _options.value = props.options;
      state.searchStr = val;
    });
    return;
  }
  update(async () => {
    const needle = val.toLowerCase();
    state.searchStr = val;
    if (props.filter) {
      emit('filter', { needle, field: props.field });
    }
    if (props.searchFromBackend && val.length >= props.searchFromBackend.min_length) {
      const searchAction = {
        ...props.searchFromBackend.action,
        customParam: JSON.stringify({
          text: needle,
        }),
      } as Action;
      const addData = await actionHandler(searchAction) as ITable;
      if (addData && typeof addData !== 'boolean') {
        _options.value = arrayUnique(_options.value.concat(addData), props.id_name);
      }
    }
  });
};

onMounted(() => {
  if (props.custom && props.valueVariant && props.valueVariant !== '0') {
    const found = props.options.find((i) => String(i[props.id_name]) === props.valueVariant);
    if (found) {
      selectedValue.value = props.valueVariant;
      if (!props.isRestoringState && found.id_type === 2) {
        emit('select', found);
      }
      changeType(found);
    }
    // if (props.autoshow) {
    //   openDialog();
    // }
  }
});

watch(() => props.valueVariant, (newVal) => {
  if (!newVal || newVal === '0') {
    selectedValue.value = null;
    return;
  }
  selectedValue.value = newVal;
}, { immediate: true });

watch(
  () => props.options,
  (newOptions) => {
    if (!newOptions?.length || !props.valueVariant || props.valueVariant === '0') {
      return;
    }

    const exists = newOptions.some(
      (o: any) => String(o[props.id_name]) === String(props.valueVariant),
    );

    if (exists) {
      selectedValue.value = props.valueVariant;

      if (!props.isRestoringState) {
        const found = newOptions.find(
          (o: any) => String(o[props.id_name]) === String(props.valueVariant),
        );
        if (found) {
          emit('select', found);
          changeType(found);
        }
      } else {
        const found = newOptions.find(
          (o: any) => String(o[props.id_name]) === String(props.valueVariant),
        );
        if (found) {
          changeType(found);
        }
      }
    }
  },
  { deep: true, immediate: true },
);

const changeType = (item: any) => {
  emit('changeType', item);
};

const select = (value: string | null = null) => {
  if (state.backspaceFlag) return;
  if (!value) return;

  selectedValue.value = value;
  const foundItem = _options.value.find(
    (opt: any) => String(opt[props.id_name]) === String(value),
  );
  if (foundItem) {
    emit('select', foundItem);
    changeType(foundItem);
  }

  state.inputMode = false;
};

const remove = () => {
  const oldValue = selectedValue.value;
  if (!oldValue) return;

  selectedValue.value = null;
  emit('update:modelValue', null);

  emit('remove', oldValue);

  nextTick(() => {
    test.value?.hidePopup();
    test.value?.reset();
    test.value?.blur();
  });
};

const popupShow = () => {
  emit('popupShow');
  state.inputMode = true;
};

const popupHide = () => {
  state.inputMode = false;
};

const closeDialog = () => {
  test.value.hidePopup();
};

const openDialog = () => {
  test.value.showPopup();
};

const currentValue = () => selectedValue.value;

expose({
  select, openDialog, closeDialog, currentValue,
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(QSelect), {
      dense: "",
      outlined: "",
      ref_key: "test",
      ref: test,
      "map-options": "",
      "emit-value": "",
      clearable: "",
      "clear-icon": "close",
      label: selectedValue.value ? '' : __props.label,
      options: _unref(applyFilter),
      "option-value": __props.id_name,
      "option-label": __props.field,
      custom: __props.custom,
      "use-input": state.inputMode,
      "input-debounce": "0",
      modelValue: selectedValue.value,
      class: _normalizeClass({
        selected: selectedValue.value,
      }),
      onFilter: filterFn,
      onClear: remove,
      behavior: "dialog",
      "onUpdate:modelValue": select,
      onPopupShow: popupShow,
      onPopupHide: popupHide,
      onKeydown: _withKeys(detectBackspace, ["delete"])
    }, _createSlots({
      prepend: _withCtx(() => [
        (state.inputMode)
          ? (_openBlock(), _createBlock(BugReport, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      append: _withCtx(() => [
        (state.inputMode)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "keyboard_arrow_up",
              onClick: _withModifiers(closeDialog, ["stop","prevent"]),
              class: "cursor-pointer"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      _renderList(_ctx.$slots, (_, slot) => {
        return {
          name: slot,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope || {})))
          ])
        }
      })
    ]), 1032, ["label", "options", "option-value", "option-label", "custom", "use-input", "modelValue", "class", "onKeydown"])
  ]))
}
}

})